import { BagIcon } from "./constants/icons";
// 拖拽預覽組件
export default function DragPreview({ node }) {
  if (!node) return null;

  const Icon = node.icon || BagIcon; // 使用預設圖標作為後備

  return (
    <div
      className={`
      p-3 sm:p-4 rounded-lg border-2 
      ${node.color || "border-gray-400 bg-gray-900/20"} 
      opacity-90 shadow-2xl transform rotate-3 scale-105
      cursor-grabbing transition-all duration-200
    `}
    >
      <div className="flex items-center gap-2 sm:gap-4">
        <div className="w-4 h-4" />
        <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
          <Icon className="flex-shrink-0" />
          <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 min-w-0">
            <span className="text-sm sm:text-base font-medium text-white truncate">
              {node.name || "未命名"}
            </span>
            <span className="text-xs sm:text-sm text-gray-300 truncate">
              {node.subName || ""}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
